/**
 * @name isValueInEnum
 *
 * @description Returns true if a value is part of a given enum
 *
 * @example
 * import { isValueInEnum } from '@workbench/core';
 *
 * isValueInEnum('February', MONTHS); // true
 */
export const isValueInEnum = (valuetoCheck: string, enumToCheck: unknown): boolean => {
  try {
    return Object.values(enumToCheck).includes(valuetoCheck);
  } catch {
    return false;
  }
};
